const BROADCAST_SIGNAL = 'broadcast_signal';
const REFRESHED_SIGNAL = 'refreshed_signal';

function inIframe() {
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
}

export function refresh(signal) {
	if (inIframe()) {
		return;
	}
	sessionStorage.setItem(REFRESHED_SIGNAL, signal);
	window.location.pathname = '/';
}

export function hasRefreshed(signal) {
	const storedSignal = sessionStorage.getItem(REFRESHED_SIGNAL);
	sessionStorage.removeItem(REFRESHED_SIGNAL);
	return storedSignal === signal;
}

export function broadcastRefresh(signal) {
	localStorage.setItem(BROADCAST_SIGNAL, signal);
	localStorage.removeItem(BROADCAST_SIGNAL);
	refresh(signal);
}

export function broadcastListen() {
	window.addEventListener('storage', ev => {
		if (ev.key === BROADCAST_SIGNAL && ev.newValue) {
			const signal = ev.newValue;
			refresh(signal);
		}
	});
}



// WEBPACK FOOTER //
// ./src/utils/broadcast-refresh.js